export default __webpack_public_path__ + "static/media/jo.f1b38503.svg";